import { createCountPopupShowedCookie } from './createCountPopupShowedCookie';

export function resetPopupShowingsHistory() {
  createCountPopupShowedCookie(0, Date.now());
}
